import { HeadCellSortState } from '@foradevelopment/fora-ui';
import { ReportedPayrollViewModel } from '@fora-monorepo/employer-my-pages-common/types';

import type { PayHistoryTableSortId } from '../types';
import { sortNumber, sortStringBasic, sortStringLocale } from './comparisonFunctions';

type TableSortState = {
  [key in PayHistoryTableSortId]?: HeadCellSortState;
};

export const sortPayHistoryListIndices = ({
  payHistoryList,
  sortState,
  indices,
}: {
  payHistoryList: ReportedPayrollViewModel[];
  sortState: TableSortState;
  indices?: number[];
}): number[] => {
  const indicesToSort = indices ?? payHistoryList.map((_, ind) => ind);

  if (Object.keys(sortState).every(state => !state)) {
    return indicesToSort;
  }
  return indicesToSort.sort((a: number, b: number) => {
    const payHistoryA = payHistoryList[a];
    const payHistoryB = payHistoryList[b];
    // Default sorting by period
    if (sortState.period) {
      return sortStringBasic(payHistoryA.payMonth, payHistoryB.payMonth, sortState.period === HeadCellSortState.Asc);
    }
    // Sorting by id
    if (sortState.id) {
      return sortStringBasic(
        payHistoryA.partnerNumberIndividual,
        payHistoryB.partnerNumberIndividual,
        sortState.id === HeadCellSortState.Asc
      );
    }
    // Sorting by organization
    if (sortState.organization) {
      return sortStringLocale(
        payHistoryA.organizationName,
        payHistoryB.organizationName,
        sortState.organization === HeadCellSortState.Asc
      );
    }
    // Sorting by firstname
    if (sortState.firstName) {
      return sortStringLocale(
        payHistoryA.firstName,
        payHistoryB.firstName,
        sortState.firstName === HeadCellSortState.Asc
      );
    }
    // Sorting by lastname
    if (sortState.lastName) {
      return sortStringLocale(payHistoryA.lastName, payHistoryB.lastName, sortState.lastName === HeadCellSortState.Asc);
    }
    //Sorting by gross salary
    if (sortState.grossSalary) {
      return sortNumber(
        payHistoryA.payAmount ? payHistoryA.payAmount : 0,
        payHistoryB.payAmount ? payHistoryB.payAmount : 0,
        sortState.grossSalary === HeadCellSortState.Asc
      );
    }
    return 0;
  });
};
